import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const POST_CREATE_NAV_ITEM = 'POST_CREATE_NAV_ITEM'
export const createNavItemApi = apiCall(
  POST_CREATE_NAV_ITEM,
  ({ siteId, ...payload }: { siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/nav-items`),
    method: 'POST',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_UPDATE_NAV_ITEM = 'POST_UPDATE_NAV_ITEM'
export const updateNavItemApi = apiCall(
  POST_UPDATE_NAV_ITEM,
  ({
    id,
    siteId,
    ...payload
  }: { id: string; siteId: string } & Record<string, unknown>) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/nav-items/${id}`),
    method: 'PATCH',
    body: payload,
    headers: appApiHeaders(),
  }),
)

const POST_DELETE_NAV_ITEM = 'POST_DELETE_NAV_ITEM'
export const deleteNavItemApi = apiCall(
  POST_DELETE_NAV_ITEM,
  ({ id, siteId }: { id: string; siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/nav-items/${id}`),
    method: 'DELETE',
    headers: appApiHeaders(),
  }),
)
